export const PAYMENT_STATUS_OPTIONS = [
  "Quoted",
  "Invoiced no p/o",
  "Invoices with p/o",
  "Part paid",
  "Paid",
] as const;

export type PaymentStatusOption = (typeof PAYMENT_STATUS_OPTIONS)[number];

export const DEFAULT_PAYMENT_STATUS: PaymentStatusOption = "Quoted";
